import PropTypes from 'prop-types'
import { useState } from 'react'
require('./index.scss')

import { FormattedMessage, useIntl } from 'react-intl'

import Dialog from '@/components/Dialog'

import CopyLink from './CopyLink'
import Email from './Email'
import Facebook from './Facebook'
import StatusMessage from './StatusMessage'
import Twitter from './Twitter'

const PDPShareTools = ({
  isFacebookSharingEnabled,
  isTwitterSharingEnabled,
  isbns,
  url
}) => {
  const [show, setShow] = useState(false)
  const [copied, setCopied] = useState(false)
  const [copyAttempted, setCopyAttempted] = useState(false)
  const intl = useIntl()

  const onLinkCopied = async () => {
    setCopyAttempted(true)
    try {
      await navigator.clipboard.writeText(url)
      setCopied(true)
    } catch (e) {
      setCopied(false)
    }
  }

  const openSocialDialog = () => {
    setShow(true)
    setCopied(false)
    setCopyAttempted(false)
  }

  return (
    <div className='pdp__share'>
      <button
        className='vst-btn--transparent u-weight--medium
          line-height-3 share-btn'
        onClick={openSocialDialog}
      >
        <FormattedMessage id='purchase.share' />
      </button>
      <Dialog
        heading={intl.formatMessage({ id: 'purchase.share' })}
        id='asset-format-modal'
        isShowing={show}
        onChangeShow={setShow}
      >
        <div className='pdp__share__modal'>
          <ul className='pdp__share__modal__wrap list-unstyled mb-0'>
            <If condition={isFacebookSharingEnabled}>
              <Facebook {...{ url }} />
            </If>
            <If condition={isTwitterSharingEnabled}>
              <Twitter />
            </If>
            <Email {...{ isbns, url }} />
            <CopyLink onClick={onLinkCopied} />
          </ul>
          <StatusMessage
            show={copyAttempted}
            success={copied}
            text={
              copied ? intl.formatMessage({ id: 'common.success_copy' })
                : intl.formatMessage({ id: 'common.failed_to_copy' })
            }
          />
        </div>
      </Dialog>
    </div>
  )
}

export default PDPShareTools

PDPShareTools.propTypes = {
  isFacebookSharingEnabled: PropTypes.bool.isRequired,
  isTwitterSharingEnabled: PropTypes.bool.isRequired,
  isbns: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
}
